import { Link } from "react-router-dom";

export default function ArticleCard({ article, featured = false, className = "" }) {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  };

  if (featured) {
    return (
      <Link
        to={`/articles/${article.slug}`}
        className={`article-card group block ${className}`}
        data-testid={`article-card-${article.slug}`}
      >
        <div className="relative aspect-[16/10] overflow-hidden bg-zinc-100">
          <img
            src={article.image_url}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
            <span className="font-accent text-xs font-bold uppercase tracking-widest text-[#FF66C4] mb-3 block">
              {article.category}
            </span>
            <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight mb-3">
              {article.title}
            </h3>
            <p className="text-white/80 line-clamp-2 mb-3 hidden md:block">
              {article.excerpt}
            </p>
            <div className="flex items-center gap-4 text-white/60 text-sm">
              <span>{article.author}</span>
              <span>•</span>
              <span>{formatDate(article.created_at)}</span>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/articles/${article.slug}`}
      className={`article-card group block ${className}`}
      data-testid={`article-card-${article.slug}`}
    >
      <div className="space-y-4">
        {/* Portrait aspect ratio image */}
        <div className="aspect-[3/4] overflow-hidden bg-zinc-100">
          <img
            src={article.image_url}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div>
          <span className="font-accent text-xs font-bold uppercase tracking-widest text-zinc-900 mb-2 block">
            {article.category}
          </span>
          <h3 className="font-serif text-lg md:text-xl font-bold leading-tight group-hover:text-[#FF66C4] transition-colors mb-3">
            {article.title}
          </h3>
          <p className="font-accent text-xs uppercase tracking-wider text-zinc-500 mb-1">
            By {article.author}
          </p>
          <p className="text-sm text-zinc-400">
            {formatDate(article.created_at)}
          </p>
        </div>
      </div>
    </Link>
  );
}
